import { render, staticRenderFns } from "./BSForm.vue?vue&type=template&id=0a013fb3&"
import script from "./BSForm.vue?vue&type=script&lang=js&"
export * from "./BSForm.vue?vue&type=script&lang=js&"
import style0 from "./BSForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports